import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { Button } from '@/components/ui/button'

/**
 * Top-level catch-all for any render/loader error react-router doesn't
 * otherwise handle — without this, an uncaught error (e.g. a bad API
 * payload shape) falls through to react-router's own unstyled default error
 * screen instead of something that looks like part of the app.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error('Unhandled route error:', error)
  }

  const description = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "We've hit a snag loading this page. Please try again."

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-4 text-center">
      <p className="font-display text-6xl text-primary">Oops</p>
      <h1 className="mt-4 text-2xl">Something went wrong</h1>
      <p className="mt-2 text-ink-muted">{description}</p>
      <div className="mt-6 flex gap-3">
        <Button variant="secondary" onClick={() => window.location.reload()}>
          Reload
        </Button>
        <Link to="/">
          <Button>Back to home</Button>
        </Link>
      </div>
    </div>
  )
}
